import React from 'react';
import { FDHeadlineText, FDImage, FDStack } from '@facet-wealth/design';
import fr from 'facet-rest';
import MetaControl from 'Components/UI/Meta/MetaControl';
import PropTypes from 'prop-types';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { dataAttrs } from 'Helpers/Testing';

const metaOverrides = buildFacetDesignOverride()
  .nameOverride('text', {
    _component: FDHeadlineText,
    _customProps: {
      size: 'sm',
      align: 'center',
    },
  }, overrideReadOnly);

export const BusinessStatistic = ({ resource }) => {
  return (
    <FDStack direction={'column'} spacing={2} alignItems={'center'} padding={4} flex={1} {...dataAttrs('scenario-business-statistic')}>
      {resource.withRelationship(fr.relationships.image.name,
        (rel) => <FDImage alt={''} height={40} src={rel.link('related').url()} rounded={false} />,
        () => null)}
      <MetaControl resource={resource} attrName={'text'} metaOverrideSet={metaOverrides} />
    </FDStack>
  );
};

BusinessStatistic.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
